import CigeErp from '../../components/cigeerp/cigeerp';

const CigeErpPage = () => {
  return <CigeErp />;
};

export default CigeErpPage;
